import React, { Fragment } from "react"
import { observer } from "mobx-react"
import { Link } from "react-router-dom"
import Price from "components/Price/Price"
import ProductCount from "components/Product/ProductCount"
import PropTypes from "prop-types"
import ProductRowCartAction from "components/Product/ProductRowCartAction"
import ListActions from "components/Product/ProductRowListAction"
import { Label, Icon } from "semantic-ui-react";
import shop from "shop/shop"
import OrderModel from "shop/OrderModel";
import Responsive from "react-responsive"


let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0
let articleOpen = 0
console.log("PRODUCTS ROW: ", shop.cart.products)
const ProductRowDefault = observer(({ product, onChange, list, cart }) => {
  let pageSize = 20
  let start = current
  current = current + pageSize
  /*shop.fetch( `/shop/rest/data/orders?start=${start}&count=${pageSize}&open=0` )
    .then( res => {
      console.log( "FROM API", { res } )
      orders = orders.concat( res.values.map( data => new OrderModel( data ) ) )
      openPositions = []
      // find orders with Open Positions
      let orderOpen = orders.filter( order => {
      return order.positions.filter( product => {
        let hasOpen = product.open && product.open !== 0
        if ( hasOpen ) {
        openPositions.push( product )
        console.log("PRODUCT: ",product)
        console.log("OPENPOSITIONS: ",openPositions)
        if(openPositions){
          if(openPositions.length > 0){
            for(let i = 0; openPositions.length > i;i++){
              if(openPositions[i].article_nr == product.article_nr){
                articleOpen = 1
              }
            }
          }
          
        }
        }
        return hasOpen
      } ).length
      } )
      
    } )
    console.log("HASOPEN:", openPositions)
    console.log("HASOPEN:", product.article_nr)
    let articleOpen = 0		
    if(openPositions){
      if(openPositions.length > 0){
        console.log("HASOPEN:", openPositions[0].article_nr)
        console.log("HASOPEN:", product.article_nr)
        for(let i = 0; openPositions.length > i;i++){
          if(openPositions[i].article_nr == product.article_nr){
            console.log("hasopenpassig")
            articleOpen = 1
          }
        }
      }
    	
    }*/
  const hasCustomVE = product.extras.Z_Verpackungseinheit_Anzahl && product.extras.Z_Verpackungseinheit_Anzahl !== "1"
  //console.log("prodcut  ",product.unit_desc)
  return (
    <Fragment>
      <tr className="bb b--black-10 w-100">
        <Responsive minWidth={790}>
          <td>
            {cart ? <ProductRowCartAction cart={cart} product={product} /> : null}
          </td>
          <td>
            <img
              className="db center"
              style={{ maxWidth: "70px", maxHeight: "70px", minWidth: "70px", minHeight: "70px", overflow: "hidden", objectFit: "contain" }}
              src={product.img_src_small}
              alt="" />
          </td>
          <td>
            <Link to={`/product/${product.map_id}`}>
              <strong>{product.article_nr}</strong> <br />
              <span className="product-title">{product.title}</span>
            </Link>
          </td>
          <td><div className="flex justify-center">{product.getNotice("tiny")}</div></td>
          <td>
            <Price>{product.price}</Price>
            <div className="flex flex-row">
              {/*product.pinfos.gc_rabatt && <div title={translate( "Coupon-Rabatt" )} className="mr1 pb2"><Label size="tiny" className={"giftcardPercent"} color="red"><span className="ttu">-{product.pinfos.gc_rabatt} %</span></Label></div>*/}
              {product.pinfos.gc_rabatt && <a title={translate("Coupon-Rabatt")} className="labelNeu1">&nbsp;&nbsp;{translate("Coupon:")} {product.pinfos.gc_rabatt} %&nbsp;&nbsp;</a>}
              {/*product.isSale && <div title={translate( "Ihr Kundenrabatt" )} className="pb2"><Label size="tiny" className={"salePercent"} color="red">-{product.salePercent}</Label></div>*/}
              {/*product.isSale && <a className="labelNeu">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>*/}
              {product.isSale && product.pinfos.sale_percent && <a className="labelNeu1">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>}
              {articleOpen == 1 && <a className="labelNeu">&nbsp;&nbsp;{translate("Rückstand")}&nbsp;&nbsp;</a>}
            </div>
          </td>
          <td>
            <div className="tr">
              <div><Price>{product.price * product.count * product.unit_multi}</Price></div>
              <div>{product.unit_multi * product.count} {translate("Stück")}</div>
            </div>
          </td>
          <td className="tr">
            <ProductCount product={product} onChange={onChange} />
          </td>
        </Responsive>
        <Responsive maxWidth={789}>
          <td className="tr pt2 pb2 pl2">
            {cart ? <ProductRowCartAction cart={cart} product={product} /> : null}
          </td>
          <td>
            <img
              className="db center"
              style={{ maxWidth: "50px", maxHeight: "50px", minWidth: "50px", minHeight: "50px", overflow: "hidden", objectFit: "contain" }}
              src={product.img_src_small}
              alt="" />
          </td>
          <td className="pt2 pb2">
            <Link to={`/product/${product.map_id}`}>
              <div className="flex"><strong>{product.article_nr}</strong><span className="pl2">{product.getNotice("tiny")}</span></div>
              <div className="product-title overflow-hidden" style={{height:"40px"}}>{product.title}</div>
            </Link>
            <div><b>{translate("Preis")}:</b> <Price>{product.price}</Price></div>
          </td>
          <td className="tl pt2 pb2">
            <ProductCount product={product} onChange={onChange} />
            <div className="tl">
              <div><b>{translate("sum")}: </b> <Price>{product.price * product.count * product.unit_multi}</Price></div>
              <div><b>{translate("Stück")}: </b> {product.unit_multi * product.count}</div>
            </div>
          </td>
        </Responsive>
      </tr>
    </Fragment>
  )
})
export default ProductRowDefault

ProductRowDefault.propTypes = {
  index: PropTypes.any,
  list: PropTypes.object,
  cart: PropTypes.object,
  onChange: PropTypes.func,
  product: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/mags/components/Product/ProductRowDefault.js